import { configureStore } from "@reduxjs/toolkit";

import { appReducer } from "./app/appReducer";
import { localeSlice } from "../modules/i18n/model/locale";

export const store = configureStore({
    reducer: {
        app: appReducer,
        locale: localeSlice.reducer,
    },
});
